import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect } from "react";
import styled from "styled-components";

export const LoadingView: React.FC = () => {
  const { reset } = useSSOStore();
  useEffect(() => {
    reset();
  }, [reset]);

  return (
    <LoginWrapper>
      <GrowingSpacer />
      <Typography variant="pageHeaderSerifRegular" align="center">
        <StrictLocalMsg
          defaultMessage="Setting up shop..."
          description={{
            text: "Text to indicating completing the registration process and loading the shop",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <StyledLoadingSpinner />
      <GrowingSpacer />
    </LoginWrapper>
  );
};

const StyledLoadingSpinner = styled(LoadingSpinner)`
  align-self: center;
`;
